module.exports = __webpack_public_path__ + "media/images/countryrect/ru-3970ca99fb00ecc292922be81f2ef5fc.svg";